import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 8px;
  background: ${COLORS.surface};
  border-radius: 8px;
  border: 1px solid ${COLORS.border};
  padding: 8px;
  /* The stage shrinks with the canvas area (CanvasWrapper is aspect-ratio +
     max-height: 100%), so on a short stage — an expanded timeline on mobile —
     this content has to fit rather than spill. The caption is the part that must
     stay readable, so it keeps its height and the illustration gives way. */
  overflow: hidden;

  & > p {
    flex-shrink: 0;
  }
`

export const IllustrationWrapper = styled.div<{ $isPortrait?: boolean }>`
  /* Shrinks to whatever the caption leaves over; min-height: 0 is what lets it
     go below the SVG's intrinsic 100px. */
  display: flex;
  min-height: 0;
  flex-shrink: 1;

  svg {
    /* The SVG carries width/height attributes (158x100) plus a viewBox, so both
       axes have to be auto for it to scale down by its intrinsic ratio; the max-*
       pair is what actually bounds it. Portrait caps the width at the same 140px
       as before (intrinsic is 158, so the unconstrained result is unchanged) but
       as a max, so a short stage can still shrink it. */
    width: auto;
    height: auto;
    max-height: 100%;
    max-width: ${({ $isPortrait }) => ($isPortrait ? '140px' : '100%')};
  }
`
